import { render, staticRenderFns } from "./_DentalInsurance.vue?vue&type=template&id=7aef5c33&"
import script from "./_DentalInsurance.vue?vue&type=script&lang=js&"
export * from "./_DentalInsurance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports